<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>
@if (Href() === undefined){
  @if (IsLabel()){
    <label 
      class="variant-{{ Variant() }}"
      [attr.type]="FormId() !== undefined ? 'submit' : 'button'"
      [attr.form]="FormId() !== undefined ? FormId() : null"
      (mousedown)="OnMouseDown($event)"
      (touchstart)="OnTouchStart($event)"
      [class.align-start]="ContentAlignment() === 'start'"
      [class.align-end]="ContentAlignment() === 'end'"
      [class.small]="Size() === 'small'"
      [class.large]="Size() === 'large'"
      [class.disabled]="Disabled()"
      [class.outline]="IsOutlined()"
      [class.no-background]="IsNoBackground()"
      [class.raised]="IsRaised()"
      [class.full-width]="FullWidth()"
      [class.full-height]="FullHeight()"
      [attr.for]="For()"
      >
      @for (ripple of Ripples(); track ripple.LocalId; let index = $index){
        <span 
          class="ripple"
          [class.is-dark]="IsRippleDark() || IsOutlined()"
          [style.--center-x]="ripple.ButtonXLocation + 'px'"
          [style.--center-y]="ripple.ButtonYLocation + 'px'"
          [style.--ripple-size]="RippleSize() + 'px'"
          (animationend)="OnAnimationEnd($event, ripple, index)"
          ></span>
      }
      <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    </label>
  } @else {
    <button 
      class="variant-{{ Variant() }}"
      [attr.type]="FormId() !== undefined ? 'submit' : 'button'"
      [attr.form]="FormId() !== undefined ? FormId() : null"
      (mousedown)="OnMouseDown($event)"
      (touchstart)="OnTouchStart($event)"
      [class.align-start]="ContentAlignment() === 'start'"
      [class.align-end]="ContentAlignment() === 'end'"
      [class.small]="Size() === 'small'"
      [class.large]="Size() === 'large'"
      [class.disabled]="Disabled()"
      [class.no-background]="IsNoBackground()"
      [class.raised]="IsRaised()"
      [class.outline]="IsOutlined()"
      [class.full-width]="FullWidth()"
      [class.full-height]="FullHeight()"
      >
      @for (ripple of Ripples(); track ripple.LocalId; let index = $index){
        <span 
          class="ripple"
          [class.is-dark]="IsRippleDark() || IsOutlined()"
          [style.--center-x]="ripple.ButtonXLocation + 'px'"
          [style.--center-y]="ripple.ButtonYLocation + 'px'"
          [style.--ripple-size]="RippleSize() + 'px'"
          (animationend)="OnAnimationEnd($event, ripple, index)"
          ></span>
      }
      <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    </button>
  }
} @else {
  @if (IsRouterLink()){
    <a 
      class="variant-{{ Variant() }}"
      [routerLink]="[`${Href()}`]"
      [queryParams]="QueryParams() !== undefined ? QueryParams() : null"
      [routerLinkActive]="ActiveClass()"
      [routerLinkActiveOptions]="{ exact: ActiveExact() }"
      (mousedown)="OnMouseDown($event)"
      (touchstart)="OnTouchStart($event)"
      [class.align-start]="ContentAlignment() === 'start'"
      [class.align-end]="ContentAlignment() === 'end'"
      [class.no-background]="IsNoBackground()"
      [class.small]="Size() === 'small'"
      [class.large]="Size() === 'large'"
      [class.raised]="IsRaised()"
      [class.disabled]="Disabled()"
      [class.outline]="IsOutlined()"
      [class.full-width]="FullWidth()"
      [class.full-height]="FullHeight()"
      >
      @for (ripple of Ripples(); track ripple.LocalId; let index = $index){
        <span 
          class="ripple"
          [class.is-dark]="IsRippleDark() || IsOutlined()"
          [style.--center-x]="ripple.ButtonXLocation + 'px'"
          [style.--center-y]="ripple.ButtonYLocation + 'px'"
          [style.--ripple-size]="RippleSize() + 'px'"
          (animationend)="OnAnimationEnd($event, ripple, index)"
          ></span>
      }
      <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    </a>
  } @else {
    <a 
      class="variant-{{ Variant() }}"
      [attr.href]="Href()"
      (mousedown)="OnMouseDown($event)"
      (touchstart)="OnTouchStart($event)"
      [class.align-start]="ContentAlignment() === 'start'"
      [class.align-end]="ContentAlignment() === 'end'"
      [class.no-background]="IsNoBackground()"
      [class.small]="Size() === 'small'"
      [class.large]="Size() === 'large'"
      [class.raised]="IsRaised()"
      [class.disabled]="Disabled()"
      [class.outline]="IsOutlined()"
      [class.full-width]="FullWidth()"
      [class.full-height]="FullHeight()"
      [attr.target]="Target() !== undefined ? Target() : null"
      [attr.download]="IsDownload() ? 'true' : null"
      >
      @for (ripple of Ripples(); track ripple.LocalId; let index = $index){
        <span 
          class="ripple"
          [class.is-dark]="IsRippleDark() || IsOutlined()"
          [style.--center-x]="ripple.ButtonXLocation + 'px'"
          [style.--center-y]="ripple.ButtonYLocation + 'px'"
          [style.--ripple-size]="RippleSize() + 'px'"
          (animationend)="OnAnimationEnd($event, ripple, index)"
          ></span>
      }
      <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    </a>
  }
}